import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AddItemsByOption,
  deleteItemsByOption,
  setOptionDescription,
  setOptionHeading,
  setOptionDisplayText,
  setOptionDiscount,
  setOptionsDescriptionObject,
  setOptionsHeading,
  setOptionsObject,
  replaceImportedCart,
  totalSelectedOptions,
  optionSelected,
  setCustomerData,
  setImportedQuoteState,
  setQuoteVersion,
} from "../../app/features/counter/counterSlice";
import Papa from "papaparse";
import axios from "axios";
import { persistor } from "../../app/store";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import "../../index.css";
import Modal from "react-bootstrap/Modal";
import HigherOrderComponent from "./HigherOrderComponent";
import JoditEditor from "jodit-react";
import DOMPurify from "dompurify";
import {
  getOptionEntries,
  DEFAULT_STANDARD_FIELDS,
  getProductSku,
  getProductDisplayName,
} from "../Templates/quoteCalculator";
import {
  VERSION,
  LEGACY_VERSION_LABEL,
} from "../../config/Version";
import { refreshImportedCartPricing, buildImportPricingChangeMessage, reviewImportPricingChanges } from "./importPriceRefresh";
// import Papa from "papaparse";

function Cart({
  combinedData,
  NumberOfOptions,
  whichOption,
  Nvr,
  camera,
  cabling,
  labor,
  poe,
  special,
  hard,
}) {
  const dispatch = useDispatch();
  const importCartInputRef = useRef(null);
  const [csvData, setCSVData] = useState([]);
  const navigate = useNavigate();
  const customerUserData = useSelector((state) => state.counter1.customerData);
  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const totalCamera = useSelector((state) => state.counter1.totalCamera);
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const selectedDrops = useSelector((state) => state.counter1.selectedDrops);
  const selectedCameraQuantity = useSelector(
    (state) => state.counter1.selectedCameraQuantity
  );
  const comparisonData = useSelector((state) => state.counter1.comparisonData);
  const [showConfirm, setShowConfirm] = useState(false);
  const [optionToCopy, setOptionToCopy] = useState(null);
  const [CartTotalAMT, setCartTotalAMT] = useState(0);
  const editor = useRef(null);
  const optionDisplayText = useSelector((state) => state.counter1.optionDisplayText || {});
  const optionDiscounts = useSelector((state) => state.counter1.optionDiscounts || {});
  const importedQuoteVersion = useSelector((state) => state.counter1.quoteVersion || "");
  const displayedQuoteVersion = importedQuoteVersion || VERSION;
  const [priceCheckProducts, setPriceCheckProducts] = useState([]);
  const [priceCheckProductOptions, setPriceCheckProductOptions] = useState([]);
  const [showBuildPacket, setShowBuildPacket] = useState(false);
  const [selectedPacketType, setSelectedPacketType] = useState("business");

  const packetTypes = [
    { value: "business", label: "Business Security Camera System" },
    { value: "home", label: "Home Security Camera System" },
    { value: "warehouse", label: "Warehouse Security Camera System" },
    { value: "property", label: "Property Management Security Camera System" },
    { value: "manufacturing", label: "Manufacturing Camera System" },
  ];

  const handleBuildPacket = () => {
    const packetQuery = encodeURIComponent(selectedPacketType || "business");
    setShowBuildPacket(false);
    navigate(`/print?packet=${packetQuery}`);
  };

  useEffect(() => {
    const loadPriceCheckCsvs = async () => {
      try {
        const [productsResponse, optionsResponse] = await Promise.all([
          axios.get("/assets/CSVs/products.csv"),
          axios.get("/assets/CSVs/product_options.csv"),
        ]);
        setPriceCheckProducts(Papa.parse(productsResponse.data, { header: true }).data || []);
        setPriceCheckProductOptions(Papa.parse(optionsResponse.data, { header: true }).data || []);
      } catch (error) {
        console.warn("Unable to load pricing CSVs for import comparison", error);
      }
    };

    loadPriceCheckCsvs();
  }, []);

  const getOptionDisplayText = (optionNumber) => {
    return optionDisplayText[optionNumber] || `OPTION ${optionNumber}`;
  };

  const handleOptionDisplayTextChange = (optionNumber, value) => {
    dispatch(setOptionDisplayText({ whichOption: optionNumber, text: value }));
  };

  const getOptionDiscount = (optionNumber) => {
    const value = Number(optionDiscounts?.[optionNumber] || 0);
    return Number.isFinite(value) ? value : 0;
  };

  const handleOptionDiscountChange = (optionNumber, value) => {
    const cleaned = String(value || "").replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    const normalized = parts.length > 1 ? `${parts[0]}.${parts.slice(1).join("")}` : cleaned;
    dispatch(setOptionDiscount({ whichOption: optionNumber, discount: normalized }));
  };

  const handleCopyOptionClick = (optionNumber) => {
    setOptionToCopy(optionNumber);
    setShowConfirm(true);
  };
  const handleConfirmCopy = () => {
    if (optionToCopy !== null) {
      handleCopyOption(optionToCopy);
      setOptionToCopy(null);
      setShowConfirm(false);
    }
  };

  const handleCancelCopy = () => {
    setOptionToCopy(null);
    setShowConfirm(false);
  };

  const makeUniqueID = () =>
    Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

  const getLineSignature = (item) => {
    const optionEntries = getCartOptionEntries(item)
      .map(
        (option) =>
          `${option.name}:${option.value}:${Number(option.price || 0).toFixed(2)}`
      )
      .sort()
      .join("|");

    return [
      item.num_options || item.option || "",
      item.Product_Name || item.id || item.Port_Name || "",
      item.Name || item.name || item.Product_Description || "",
      item.Product_Quantity ||
        item.Camera_Quantity ||
        item.Port_Quantity ||
        item.quantity ||
        "",
      item.Product_Final_Price ||
        item.Camera_Final_Price ||
        item.poeFinalPrice ||
        item.totalPriceForItem ||
        "",
      optionEntries,
    ].join("::");
  };

  const dedupeSpecialItems = (items = []) => {
    const seen = new Set();

    return items.filter((item) => {
      const signature = getLineSignature(item);
      if (seen.has(signature)) return false;
      seen.add(signature);
      return true;
    });
  };

  const sanitizeCartSnapshot = (snapshot) => ({
    ...snapshot,
    selectedSpecial: dedupeSpecialItems(snapshot.selectedSpecial || []),
  });

  // Function to copy the items from one cart to another cart
  const handleCopyOption = (optionNumber) => {
    // optionNumber holds the option number that you want to copy into the current option.
    // Important: auto-added labor items are linked to parent items by uniqueID.
    // When copying an option, the parent items receive new uniqueIDs, so copied
    // auto-labor must be remapped to the copied parent IDs or it will not be
    // removed when the copied NVR/enclosure is deleted later.

    const allItems = [
      ...Nvr.map((item) => ({ ...item, category: "nvr" })),
      ...camera.map((item) => ({ ...item, category: "camera" })),
      ...cabling.map((item) => ({ ...item, category: "cabling" })),
      ...labor.map((item) => ({ ...item, category: "labor" })),
      ...poe.map((item) => ({ ...item, category: "poe" })),
      ...special.map((item) => ({ ...item, category: "special" })),
      ...hard.map((item) => ({ ...item, category: "hardware" })),
    ];

    const filteredData = allItems.filter(
      (item) => String(item.num_options) === String(optionNumber)
    );

    const uniqueIdMap = {};

    // First assign new uniqueIDs to every source line.
    const updatedDataa = filteredData.map((item) => {
      const oldUniqueID = item.uniqueID;
      const newUniqueID = makeUniqueID();

      if (oldUniqueID) {
        uniqueIdMap[oldUniqueID] = newUniqueID;
      }

      return {
        ...item,
        uniqueID: newUniqueID,
        num_options: whichOption,
      };
    });

    // Then remap copied auto-added labor to the copied parent item.
    const remappedData = updatedDataa.map((item) => {
      if (
        item.category === "labor" &&
        item.autoAdded === true &&
        item.linkedParentUniqueID &&
        uniqueIdMap[item.linkedParentUniqueID]
      ) {
        return {
          ...item,
          linkedParentUniqueID: uniqueIdMap[item.linkedParentUniqueID],
        };
      }

      return item;
    });

    const categories = [
      "selectedNVR",
      "selectedCamera",
      "selectedCabling",
      "selectedLabor",
      "selectedPoE",
      "selectedHardWare",
      "selectedSpecial",
    ];

    categories.forEach((category) => {
      dispatch(
        deleteItemsByOption({ category: category, whichOption: whichOption })
      );

      const categoryName = category.replace("selected", "").toLowerCase();
      let itemsToBeAdded = remappedData.filter((item) => {
        return item.category.toLowerCase().includes(categoryName);
      });

      if (category === "selectedSpecial") {
        itemsToBeAdded = dedupeSpecialItems(itemsToBeAdded);
      }

      dispatch(AddItemsByOption({ category: category, items: itemsToBeAdded }));
    });
  };

  //Download CSV Starts
  const downloadCSV = () => {
    const updatedData = combinedData.map((item, index) => {
      const { page, ...rest } = item;
      if (index === 0) {
        return { globalOption: totalNoOptions, ...rest };
      } else {
        return rest;
      }
    });
    const csv = Papa.unparse(updatedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  //Download CSV Ends

  // Function to export cart data to CSV
  // const exportCartData = () => {
  //   // Define CSV headers
  //   const headers = [
  //     "Option",
  //     "Page",
  //     "Category",
  //     "Product Name",
  //     "Image",
  //     "Quantity",
  //     "Base Price",
  //     "Final Price",
  //     "Quote Number",
  //     "Subtotal",
  //     "Cart Description",
  //     "Customer Name",
  //     "Phone Number",
  //     "Email",
  //     "Billing Address",
  //     "Shipping Address",
  //   ];

  //   const isSubtotaltrue = {}; // Object to track if subtotal is already calculated
  //   let subtotal; // Variable to store subtotal for each option

  //   // Map over the cart data to create rows for each cart item
  //   const rows = combinedData.map((cart) => {
  //     // Check if subtotal has been calculated for this option
  //     if (!isSubtotaltrue[cart.option]) {
  //       // Calculate subtotal for this cart.option if not done already
  //       subtotal = combinedData
  //         .filter((item) => item.option === cart.option)
  //         .reduce((total, item) => total + (item.Product_Final_Price || 0), 0); // Sum Product_Final_Price for each item

  //       // Mark that subtotal has been calculated for this option
  //       isSubtotaltrue[cart.option] = true;
  //     }

  //     return [
  //       cart.option,
  //       cart.page,
  //       cart.category,
  //       cart.Product_Name,
  //       cart.image || "", // Handle cases where 'image' might be undefined
  //       cart.Product_Quantity,
  //       cart.Product_Base_Price,
  //       cart.Product_Final_Price,
  //       `Quote# ${QuoteNumber()}-${cart.option}`, // Custom quote number
  //       subtotal.toFixed(2), // Subtotal for the cart
  //       DOMPurify.sanitize(optionDescription[cart.option]) || "", // Cart description
  //       customerUserData.businessName || "",
  //       customerUserData.phoneNumber || "",
  //       customerUserData.email || "",
  //       `${customerUserData.billAddress1 || ""}, ${customerUserData.billAddress2 || ""
  //       }, ${customerUserData.billCity || "Billing City"}, ${customerUserData.billState || "Billing State"
  //       }, ${customerUserData.billZip || "Billing Zip"}`,
  //       `${customerUserData.shipAddress1 || ""}, ${customerUserData.shipAddress2 || ""
  //       }, ${customerUserData.shipCity || "Shipping City"}, ${customerUserData.shipState || "Shipping State"
  //       }, ${customerUserData.shipZip || "Shipping Zip"}`,
  //     ];
  //   });

  //   // Convert data to CSV format
  //   const csvContent = [
  //     headers.join(","), // Header row
  //     ...rows.map((row) => row.join(",")), // Data rows
  //   ].join("\n");

  //   // Create a Blob with CSV data and trigger download
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   saveAs(blob, "cart-data.csv");
  // };

  const getSourceCartItemsForExport = () => [
    ...Nvr.map((item) => ({ bucket: "selectedNVR", item })),
    ...camera.map((item) => ({ bucket: "selectedCamera", item })),
    ...cabling.map((item) => ({ bucket: "selectedCabling", item })),
    ...labor.map((item) => ({ bucket: "selectedLabor", item })),
    ...poe.map((item) => ({ bucket: "selectedPoE", item })),
    ...special.map((item) => ({ bucket: "selectedSpecial", item })),
    ...hard.map((item) => ({ bucket: "selectedHardWare", item })),
  ];

  const getExportQuantity = (item) => {
    return Number(
      item.Product_Quantity ||
        item.Camera_Quantity ||
        item.NVR_Quantity ||
        item.Port_Quantity ||
        item.quantity ||
        1
    );
  };

  const getExportUnitPrice = (item) => {
    const firstValidNumber = (...values) => {
      for (const value of values) {
        if (value === undefined || value === null || value === "") continue;
        const numericValue = Number(value);
        if (!Number.isNaN(numericValue)) return numericValue;
      }
      return null;
    };

    const directUnitPrice = firstValidNumber(
      item.unitprice,
      item.pricePerItem,
      item.basePrice3,
      item.Product_Base_Price,
      item.Camera_Base_Price,
      item.Port_Base_Price,
      item.NVR_Base_Price,
      item.price
    );

    if (directUnitPrice !== null) return directUnitPrice;

    const qty = getExportQuantity(item);
    if (item.Product_Final_Price !== undefined && qty) {
      return Number(item.Product_Final_Price || 0) / qty;
    }
    if (item.Camera_Final_Price !== undefined) {
      return Number(item.Camera_Final_Price || 0);
    }
    if (item.poeFinalPrice !== undefined) {
      return Number(item.poeFinalPrice || 0);
    }

    return 0;
  };

  const getExportLineTotal = (item, unitPrice, optionUnitCost, quantity) => {
    if (item.Product_Final_Price !== undefined) {
      return Number(item.Product_Final_Price || 0);
    }
    if (item.Camera_Final_Price !== undefined) {
      return Number(item.Camera_Final_Price || 0) * quantity;
    }
    if (item.poeFinalPrice !== undefined) {
      return Number(item.poeFinalPrice || 0) * quantity;
    }
    if (item.Hardware_New_Final_Price !== undefined) {
      return Number(item.Hardware_New_Final_Price || 0);
    }
    if (item.test !== undefined) {
      return Number(item.test || 0);
    }
    if (item.totalPriceForItem !== undefined) {
      return Number(item.totalPriceForItem || 0) * quantity;
    }

    return (unitPrice + optionUnitCost) * quantity;
  };

  const getExportSku = (item) => getProductSku(item);

  const buildExportRows = () => {
    const cartSnapshot = sanitizeCartSnapshot({
      selectedNVR: Nvr || [],
      selectedCamera: camera || [],
      selectedCabling: cabling || [],
      selectedLabor: labor || [],
      selectedPoE: poe || [],
      selectedSpecial: special || [],
      selectedHardWare: hard || [],
    });

    const metadataRow = {
      row_type: "quote_metadata",
      app_version: VERSION,
      quote_version: VERSION,
      exported_with_version: VERSION,
      total_no_options: totalNoOptions || NumberOfOptions || 1,
      total_camera: totalCamera || 0,
      customer_data_json: JSON.stringify(customerUserData || {}),
      option_heading_json: JSON.stringify(optionHeading || {}),
      option_display_text_json: JSON.stringify(optionDisplayText || {}),
      option_discounts_json: JSON.stringify(optionDiscounts || {}),
      option_description_json: JSON.stringify(optionDescription || {}),
      selected_drops_json: JSON.stringify(selectedDrops || {}),
      selected_camera_quantity_json: JSON.stringify(selectedCameraQuantity || {}),
      comparison_data_json: JSON.stringify(comparisonData || {}),
      cart_snapshot_json: JSON.stringify(cartSnapshot),
    };

    const itemRows = getSourceCartItemsForExport().map(({ bucket, item }) => {
      const options = getCartOptionEntries(item);
      const quantity = getExportQuantity(item);
      const unitPrice = getExportUnitPrice(item);
      const optionUnitCost = options.reduce(
        (sum, option) => sum + Number(option.price || 0),
        0
      );
      const lineTotal = getExportLineTotal(
        item,
        unitPrice,
        optionUnitCost,
        quantity
      );

      const itemForExport = {
        ...item,
        cart_bucket: bucket,
        num_options: item.num_options || item.option || whichOption,
      };

      const row = {
        row_type: "cart_item",
        cart_bucket: bucket,
        uniqueID: item.uniqueID || "",
        num_options: item.num_options || item.option || whichOption,
        sku: getExportSku(item),
        name: getCartDisplayName(item),
        quantity,
        unit_price: unitPrice,
        option_unit_cost: optionUnitCost,
        option_cost: optionUnitCost * quantity,
        line_total: lineTotal,
        raw_item_json: JSON.stringify(itemForExport),
        options_json: JSON.stringify(options),
      };

      options.forEach((option, index) => {
        const slot = index + 1;
        row[`option${slot}_name`] = option.name;
        row[`option${slot}_value`] = option.value;
        row[`option${slot}_price`] = option.price;
      });

      return row;
    });

    return [metadataRow, ...itemRows];
  };

  const downloadBlobFallback = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const exportCartData = async () => {
    const csv = Papa.unparse(buildExportRows());
    const fileName = `${QuoteNumber()}.csv`;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    if (window.isSecureContext && window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: "CSV files",
              accept: { "text/csv": [".csv"] },
            },
          ],
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        dispatch(setQuoteVersion(VERSION));
        return;
      } catch (error) {
        if (error?.name === "AbortError") return;
        console.warn("Save As dialog failed; falling back to standard download.", error);
      }
    }

    downloadBlobFallback(blob, fileName);
    dispatch(setQuoteVersion(VERSION));
  };

  // Uplaod CSV Starts Here
  const groupedOptions = [];
  if (totalNoOptions !== undefined) {
    for (let i = 1; i <= totalNoOptions; i++) {
      groupedOptions.push(
        combinedData.filter((item) => item.option === i.toString())
      );
    }
  } else {
    groupedOptions.push(combinedData.filter((item) => item.option === "1"));
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      const rows = text.split("\n").map((row) => row.split(","));
      setCSVData(rows);
    };

    reader.readAsText(file);
  };

  const tableStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  };
  const tableHeaderStyle = {
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "10px",
    textAlign: "left",
    backgroundColor: "rgba(201, 201, 201, 1)",
  };

  const buttonStyle = {
    backgroundColor: "#4caf50",
    border: "none",
    color: "white",
    padding: "15px 32px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    margin: "4px 2px",
    cursor: "pointer",
  };
  const btnEdit = {
    backgroundColor: "#212529",
    padding: "5px 10px",
    borderRadius: "8px",
    color: "#fff",
    textDecoration: "none",
  };

  const paddingTest = {
    tr: {
      background: "lightgray",
    },
    td: {
      paddingLeft: "10px",
    },
  };

  const optionStyle = {
    marginTop: "150px",
  };

  const copyBtn = {
    marginLeft: "5px",
    marginBottom: "5px",
  };

  const clearCartBtn = {
    marginLeft: "5px",
    marginBottom: "13px",
  };

  const imgLogo = {
    width: "200px",
    height: "100px",
  };


  const cartTableStyle = {
    tableLayout: "fixed",
    width: "100%",
    minWidth: "760px",
  };

  const cartColumnStyles = {
    sku: {
      width: "11%",
      minWidth: "105px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "top",
    },
    description: {
      width: "60%",
      minWidth: "420px",
      whiteSpace: "normal",
      wordBreak: "normal",
      overflowWrap: "break-word",
      verticalAlign: "top",
      lineHeight: "1.35",
    },
    price: {
      width: "7%",
      minWidth: "85px",
      whiteSpace: "nowrap",
      textAlign: "right",
      verticalAlign: "top",
    },
    qty: {
      width: "10%",
      minWidth: "55px",
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "top",
    },
    total: {
      width: "12%",
      minWidth: "95px",
      whiteSpace: "nowrap",
      textAlign: "right",
      verticalAlign: "top",
    },
  };

  // Render DummyComponent based on the value of numberOfComponents
  const renderDummyComponents = () => {
    const components = [];
    for (let i = 0; i < NumberOfOptions; i++) {
      components.push(<SelectedItem key={i} />);
    }
    return components;
  };

  const handleClearState = () => {
    localStorage.removeItem("productAdded");
    localStorage.removeItem("warning");
    persistor.purge();
    window.location.reload();
  };

  // const filteredCategories = (whichOption) => {
  //   const categories = new Set(
  //     combinedData
  //       .filter((item) => item.option == whichOption)
  //       .flatMap((item) => {
  //         // Split the combined category into two separate categories
  //         if (item.category === "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles") {
  //           return [
  //             "DVRs & NVRs/NVR Recorders (IP Cameras)",
  //             "Special/Software and Dongles",
  //           ];
  //         }
  //         return [item.category];
  //       })
  //   );
  //   return Array.from(categories);
  // };

  const getCartCategorySortOrder = (category) => {
    if (category === "DVRs & NVRs/NVR Recorders (IP Cameras)") return 10;
    if (
      category ===
      "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles"
    ) {
      return 11;
    }
    if (category === "Camera") return 20;
    if (category === "Poe") return 30;
    if (category === "Cabling") return 40;
    if (category === "Special") return 50;
    if (category === "Hardware") return 60;
    if (category === "Labor") return 999;

    return 500;
  };

  const getCartCategoryHeading = (category) => {
    if (
      category === "DVRs & NVRs/NVR Recorders (IP Cameras)" ||
      category ===
        "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles"
    ) {
      return "NVRs";
    }

    if (category === "Camera") return "Cameras";
    if (category === "Poe") return "PoE Switches";

    return category;
  };

  const isNvrCartCategory = (category) =>
    category === "DVRs & NVRs/NVR Recorders (IP Cameras)" ||
    category ===
      "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles";

  const filteredCategories = (whichOption) => {
    return Array.from(
      new Set(
        combinedData
          .filter(
            (item) =>
              item.option == whichOption &&
              item.category !==
              "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles"
          )
          .map((cat) => cat.category)
      )
    ).sort((a, b) => getCartCategorySortOrder(a) - getCartCategorySortOrder(b));
  };

  // const storeDrops = useSelector((state) => state.counter1.selectedNumberOfDrops);
  // const filteredOptions = () => {
  //   const dropToDisplay = groupedOptions
  //     .filter(options => options.length > 0)
  //     .flatMap(options => {
  //       let cartNumber = "";
  //       let totalDropToDisplay = 0;
  //       let totalCamera = 0;
  //       options.forEach(item => {
  //         cartNumber = item.option
  //
  //         totalCamera += parseInt(item.Product_Quantity, 10);
  //         if (item.drops) {
  //           totalDropToDisplay += parseInt(item.drop, 10) * item.Product_Quantity;
  //         }
  //       });
  //       let final = totalCamera + totalDropToDisplay;
  //       // dispatch(setSelectedNumberOfDrops({ [cartNumber]: final }));
  //     });
  // };

  // useEffect(() => {
  //   filteredOptions()
  // }, [whichOption])

  const totalQuantities = () => {
    let categories = ["Camera", "Labor", "Hardware"];

    const items = combinedData.filter((item) => item.option === whichOption);

    const totalQuantities = {
      Camera: 0,
      Poe: 0,
      Labor: 0,
      Hardware: 0,
      Licenses: 0,
      Drops: 0,
    };

    items.forEach((item) => {
      if (categories.includes(item.category)) {
        totalQuantities[item.category] += parseInt(item.Product_Quantity, 10);
        //calculate drops if present
        if (item.drop) {
          totalQuantities.Drops +=
            parseInt(item.drop, 10) * item.Product_Quantity;
        }
      } else if (item.licenses !== undefined) {
        totalQuantities.Licenses += parseInt(item.licenses, 10);
        //calculate drops if present
        if (item.drop) {
          totalQuantities.Drops +=
            parseInt(item.drop, 10) * item.Product_Quantity;
        }
      } else if (item.drop !== undefined) {
        totalQuantities.Drops +=
          parseInt(item.drop, 10) * item.Product_Quantity;
      } else if (item.category === "Poe") {
        // Use the below if you only want to see the poe port per item
        totalQuantities.Poe += parseInt(item.num_poe_ports, 10);

        // use it if you want to see poe port multiplied with the quantity
        // totalQuantities.Poe += parseInt(item.num_poe_ports, 10) * item.Product_Quantity;

        //calculate drops if present
        if (item.drop) {
          totalQuantities.Drops +=
            parseInt(item.drop, 10) * item.Product_Quantity;
        }
      }
    });
    return totalQuantities;
  };

  const totalQuantity = totalQuantities();

  // const categoryPaths = combinedData.reduce((acc, item) => {
  //   if (!acc[item.category]) {
  //     acc[item.category] = item.page;
  //   }
  //   // Add mapping for split categories
  //   if (item.category === "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles") {
  //     acc["DVRs & NVRs/NVR Recorders (IP Cameras)"] = item.page;
  //     acc["Special/Software and Dongles"] = item.page; // Or set a specific page for Special/Software and Dongles
  //   }
  //   return acc;
  // }, {});

  const categoryPaths = combinedData.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = item.page;
    }
    return acc;
  }, {});

  const sanitizeFileNamePart = (value, fallback = "") => {
    const text = String(value || "")
      .trim()
      .replace(/[\\/:*?"<>|]+/g, " ")
      .replace(/\s+/g, " ");

    return text || fallback;
  };

  const QuoteNumber = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear().toString().slice(-2);
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    const lastName = sanitizeFileNamePart(customerUserData.customerLastName, "XXX");
    const firstThreeLetters = lastName ? lastName.substring(0, 3) : "XXX";

    return `${year}${month}${day}-${firstThreeLetters}`;
  };

  const getCustomerFileNamePart = () => {
    const businessName = sanitizeFileNamePart(customerUserData.businessName);
    if (businessName) return businessName;

    const lastName = sanitizeFileNamePart(customerUserData.customerLastName, "Customer");
    return `${lastName} Home`;
  };

  const QuoteFileName = () => {
    const quoteNumber = QuoteNumber();
    const optionCount = totalNoOptions || NumberOfOptions || 1;
    const quoteRange = optionCount > 1
      ? `${quoteNumber}-1-${optionCount}`
      : `${quoteNumber}-1`;

    return `${quoteRange} - ${getCustomerFileNamePart()} - Security Camera System Quotes - 👁Platinum CCTV`;
  };

  // const exCategories =
  //     groupedOptions
  //       .filter(options => options.length > 0) // Filter out empty options arrays
  //       .flatMap(options => options.map(item => item.category))

  const optionHeading = useSelector((state) => state.counter1.optionHeading);
  const optionDescription = useSelector(
    (state) => state.counter1.optionDescription
  );

  const handleOptionHeadingChange = (whichOption, e) => {
    const text = e.target.value;
    dispatch(setOptionHeading({ whichOption, text })); // Ensure payload is an object
  };

  const handleOptionDescriptionChange = (whichOption, text) => {
    dispatch(setOptionDescription({ whichOption, text }));
  };

  useEffect(() => {
    const total = combinedData
      .filter((item) => item.option === whichOption)
      .reduce((sum, item) => sum + getCartLineTotal(item), 0);

    setCartTotalAMT(total);
  }, [combinedData, whichOption]);

  const CART_EXTRA_STANDARD_FIELDS = [
    "page",
    "image",
    "Product_Final_Price",
    "Product_Base_Price",
    "Product_Quantity",
    "cart_bucket",
    "raw_item_json",
    "options_json",
    "globalOption",
    "cableColorPrice",
    "cableColourPrice",
    "cable_color_price",
    "Cable Color_price",
    "num_poe_ports",
    "num_poe_ports_price",
    "Numb PoE Ports",
    "Numb PoE Ports_price",
    "Number of PoE Ports",
    "Number of PoE Ports_price",
    "optionCameras",
    "optionCameras_price",
    "Option Cameras Selected",
    "Option Cameras Selected_price",
    "licenses",
    "licenses_price",
    "Licenses",
    "Licenses_price",
    "cart_bucket",
  ];

  const FRIENDLY_OPTION_NAMES = {
    cableColor: "Cable Color",
    cableColour: "Cable Color",
    cable_color: "Cable Color",
  };

  const HIDDEN_OPTION_DISPLAY_NAMES = new Set([
    "Option Cameras Selected",
    "Licenses",
    "Number Of Poe Ports",
    "Numb Poe Ports",
    "Cart Bucket",
  ]);

  const toFriendlyOptionName = (name) => {
    if (FRIENDLY_OPTION_NAMES[name]) return FRIENDLY_OPTION_NAMES[name];
    if (!name) return "";

    return String(name)
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getCartDisplayName = (item) => getProductDisplayName(item);

  const toCartNumber = (value, fallback = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const getCartQuantity = (item) => {
    return toCartNumber(
      item.Product_Quantity ||
        item.Camera_Quantity ||
        item.NVR_Quantity ||
        item.Port_Quantity ||
        item.quantity,
      1
    );
  };

  const getCartSavedLineTotal = (item) => {
    const quantity = getCartQuantity(item);

    if (item.Product_Final_Price !== undefined) {
      return toCartNumber(item.Product_Final_Price);
    }

    if (item.Hardware_New_Final_Price !== undefined) {
      return toCartNumber(item.Hardware_New_Final_Price);
    }

    if (item.test !== undefined) {
      return toCartNumber(item.test);
    }

    if (item.Camera_Final_Price !== undefined) {
      return toCartNumber(item.Camera_Final_Price) * quantity;
    }

    if (item.totalPriceForItem !== undefined) {
      return toCartNumber(item.totalPriceForItem) * quantity;
    }

    return null;
  };

  const getCartBaseUnitPrice = (item) => {
    if (item.unitprice !== undefined) return toCartNumber(item.unitprice);
    if (item.pricePerItem !== undefined) return toCartNumber(item.pricePerItem);
    if (item.basePrice3 !== undefined) return toCartNumber(item.basePrice3);
    if (item.poeFinalPrice !== undefined) return toCartNumber(item.poeFinalPrice);
    if (item.Product_Base_Price !== undefined) return toCartNumber(item.Product_Base_Price);
    return 0;
  };

  const getCartUnitPrice = (item) => {
    const quantity = getCartQuantity(item);
    const savedLineTotal = getCartSavedLineTotal(item);

    // Display unit price should include selected options.
    // Saved line totals are more reliable than base unit fields for NVRs
    // and other category rows where selected options are stored separately.
    if (savedLineTotal !== null && quantity) {
      return savedLineTotal / quantity;
    }

    return getCartBaseUnitPrice(item);
  };

  const getCartLineTotal = (item) => {
    const savedLineTotal = getCartSavedLineTotal(item);
    if (savedLineTotal !== null) return savedLineTotal;

    return getCartUnitPrice(item) * getCartQuantity(item);
  };

  const getOptionCount = () => Number(totalNoOptions || NumberOfOptions || 1);

  const cartBuckets = {
    selectedCamera: camera || [],
    selectedCabling: cabling || [],
    selectedLabor: labor || [],
    selectedNVR: Nvr || [],
    selectedPoE: poe || [],
    selectedHardWare: hard || [],
    selectedSpecial: special || [],
  };

  const normalizeOptionNumber = (value) => String(value || "1");

  const remapOptionItem = (item, removedOptionNumber) => {
    const currentOption = Number(item.num_options || item.option || 1);

    if (currentOption === removedOptionNumber) {
      return null;
    }

    if (currentOption > removedOptionNumber) {
      const shiftedOption = String(currentOption - 1);
      return {
        ...item,
        num_options: shiftedOption,
        option: shiftedOption,
      };
    }

    return item;
  };

  const handleAddOption = () => {
    const nextOptionCount = getOptionCount() + 1;
    const nextOption = String(nextOptionCount);

    dispatch(totalSelectedOptions(nextOptionCount));
    dispatch(optionSelected(nextOption));
    dispatch(setOptionDisplayText({ whichOption: nextOption, text: `OPTION ${nextOption}` }));
  };

  const handleRemoveOption = () => {
    const optionCount = getOptionCount();
    if (optionCount <= 1) return;

    // Always remove the highest-numbered option so the option tabs and
    // page headers stay aligned with their option numbers.
    const removedOptionNumber = optionCount;
    const nextOptionCount = optionCount - 1;
    const currentSelectedOption = Number(whichOption || 1);
    const nextSelectedOption = String(
      currentSelectedOption > nextOptionCount ? nextOptionCount : currentSelectedOption
    );

    const remappedBuckets = Object.fromEntries(
      Object.entries(cartBuckets).map(([bucket, items]) => [
        bucket,
        (items || [])
          .map((item) => remapOptionItem(item, removedOptionNumber))
          .filter(Boolean),
      ])
    );

    dispatch(replaceImportedCart(remappedBuckets));
    dispatch(totalSelectedOptions(nextOptionCount));
    dispatch(optionSelected(nextSelectedOption));
  };
  const renderOptionCountControls = () => (
    <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
      <div className="border rounded bg-light fw-bold px-3 py-2">
        Total Options: {getOptionCount()}
      </div>
      <Button
        variant="danger"
        className="fw-bold px-3"
        onClick={handleRemoveOption}
        disabled={getOptionCount() <= 1}
        aria-label="Remove option"
        title="Remove current option"
      >
        -
      </Button>
      <Button
        variant="danger"
        className="fw-bold px-3"
        onClick={handleAddOption}
        aria-label="Add option"
        title="Add option"
      >
        +
      </Button>
    </div>
  );

  const getCartOptionItems = () => {
    return combinedData.filter((item) => item.option === whichOption);
  };

  const getCartPartsTotal = () => {
    return getCartOptionItems()
      .filter((item) => item.category !== "Labor")
      .reduce((total, item) => total + getCartLineTotal(item), 0);
  };

  const getCartLaborTotal = () => {
    return getCartOptionItems()
      .filter((item) => item.category === "Labor")
      .reduce((total, item) => total + getCartLineTotal(item), 0);
  };

  const renderCartControls = () => (
    <div className="col-12 d-flex justify-content-center mb-4">
      <div className="d-flex justify-content-center mx-3">
        <Button variant="dark" onClick={exportCartData}>
          Download CSV
        </Button>
      </div>
      <div className="d-flex justify-content-center mx-3">
        <Button
          variant="dark"
          onClick={() => importCartInputRef.current?.click()}
        >
          Import CSV
        </Button>
        <input
          ref={importCartInputRef}
          type="file"
          accept=".csv,text/csv"
          style={{ display: "none" }}
          onChange={importCartCsv}
        />
      </div>
      {combinedData.length > 0 && (
        <div className="d-flex justify-content-center mx-3">
          <Button variant="dark" onClick={() => navigate(`/print`)}>
            Print
          </Button>
        </div>
      )}
      {combinedData.length > 0 && (
        <div className="d-flex justify-content-center mx-3">
          <Button variant="dark" onClick={() => setShowBuildPacket(true)}>
            Build Packet
          </Button>
        </div>
      )}
      {totalNoOptions !== undefined ? (
        <div className="d-flex justify-content-center mx-3">
          <Button variant="dark" onClick={handleClearState}>
            Clear Cart
          </Button>
        </div>
      ) : null}
    </div>
  );

  const getCartOptionEntries = (item) => {
    const entries = getOptionEntries(item, CART_EXTRA_STANDARD_FIELDS)
      .map((option) => ({
        ...option,
        name: toFriendlyOptionName(option.name),
      }))
      .filter((option) => !HIDDEN_OPTION_DISPLAY_NAMES.has(option.name));

    const standardFields = new Set([
      ...DEFAULT_STANDARD_FIELDS,
      ...CART_EXTRA_STANDARD_FIELDS,
    ]);

    Object.keys(item || {}).forEach((key) => {
      let rawName = "";
      let value;
      let price;

      if (key.endsWith("_price")) {
        rawName = key.slice(0, -6);
        value = item[rawName];
        price = item[key];
      } else if (key.endsWith("Price")) {
        rawName = key.slice(0, -5);
        value = item[rawName];
        price = item[key];
      } else {
        return;
      }

      if (standardFields.has(rawName)) return;
      if (/^option\d+$/.test(rawName)) return;
      if (value === undefined || value === null || value === "") return;

      const friendlyName = toFriendlyOptionName(rawName);
      const existingEntry = entries.find(
        (entry) =>
          entry.name === friendlyName && String(entry.value) === String(value)
      );

      if (HIDDEN_OPTION_DISPLAY_NAMES.has(friendlyName)) return;

      if (existingEntry) {
        existingEntry.price = Number(price || existingEntry.price || 0);
        return;
      }

      entries.push({
        name: friendlyName,
        value,
        price: Number(price || 0),
      });
    });

    const dedupedEntries = [];
    const seenEntries = new Map();

    entries.forEach((entry) => {
      if (
        !entry.name ||
        entry.value === undefined ||
        entry.value === null ||
        entry.value === "" ||
        typeof entry.value === "object"
      ) {
        return;
      }

      const normalizedName = toFriendlyOptionName(entry.name);
      const signature = `${normalizedName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "")}::${String(entry.value)
        .toLowerCase()
        .trim()}`;

      if (seenEntries.has(signature)) {
        const existingEntry = seenEntries.get(signature);
        const existingPrice = Number(existingEntry.price || 0);
        const newPrice = Number(entry.price || 0);

        if (!existingPrice && newPrice) {
          existingEntry.price = newPrice;
        }

        return;
      }

      const cleanEntry = {
        ...entry,
        name: normalizedName,
        price: Number(entry.price || 0),
      };

      seenEntries.set(signature, cleanEntry);
      dedupedEntries.push(cleanEntry);
    });

    return dedupedEntries;
  };

  const renderCartDescription = (item) => {
    const options = getCartOptionEntries(item);

    return (
      <>
        <strong>{getCartDisplayName(item)}</strong>
        <br />

        {item.category === "Poe" && item.num_poe_ports ? (
          <>
            <strong>No. of POE Ports - </strong>
            {item.num_poe_ports}
            <br />
          </>
        ) : null}

        {options.map((option, optionIndex) => (
          <React.Fragment key={`${option.name}-${optionIndex}`}>
            <strong>{option.name} - </strong>
            {option.value}{" "}
            <strong>${Number(option.price || 0).toFixed(2)}</strong>
            <br />
          </React.Fragment>
        ))}
      </>
    );
  };

  const getImportBucket = (item, row = {}) => {
    if (
      row.cart_bucket &&
      [
        "selectedCamera",
        "selectedCabling",
        "selectedLabor",
        "selectedNVR",
        "selectedPoE",
        "selectedHardWare",
        "selectedSpecial",
      ].includes(row.cart_bucket)
    ) {
      return row.cart_bucket;
    }

    if (!item || typeof item !== "object") return "selectedSpecial";

    if (
      item.cart_bucket &&
      [
        "selectedCamera",
        "selectedCabling",
        "selectedLabor",
        "selectedNVR",
        "selectedPoE",
        "selectedHardWare",
        "selectedSpecial",
      ].includes(item.cart_bucket)
    ) {
      return item.cart_bucket;
    }

    if (
      item.category === "DVRs & NVRs/NVR Recorders (IP Cameras)" ||
      item.category ===
        "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles" ||
      item.NVR_Name ||
      item.nvrName ||
      item.NVR_Quantity
    ) {
      return "selectedNVR";
    }

    if (item.category === "Camera" || item.Camera_Quantity) {
      return "selectedCamera";
    }

    if (item.category === "Cabling" || item.cableColor || item["Cable Color"]) {
      return "selectedCabling";
    }

    if (item.category === "Labor" || item.extra_field_4 !== undefined) {
      return "selectedLabor";
    }

    if (item.category === "Poe" || item.Port_Name || item.Port_Quantity) {
      return "selectedPoE";
    }

    if (
      item.category === "Hardware" ||
      item.Hardware_Total_data ||
      item.HardWare_Base_Price ||
      item.Hardware_New_Final_Price
    ) {
      return "selectedHardWare";
    }

    return "selectedSpecial";
  };

  const buildImportedItemFromRow = (row) => {
    const bucket = row.cart_bucket || "selectedSpecial";
    const quantity = Number(row.quantity || row.Product_Quantity || row.Quantity || 1);
    const unitPrice = Number(row.unit_price || row.Product_Base_Price || row["Base Price"] || 0);
    const optionUnitCost = Number(row.option_unit_cost || 0);
    const lineTotal = Number(row.line_total || row.Product_Final_Price || row["Final Price"] || 0);
    const resolvedUnitPrice = unitPrice || (quantity ? lineTotal / quantity : 0);

    const item = {
      uniqueID:
        row.uniqueID ||
        Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
      num_options: row.num_options || row.option || whichOption,
      option: row.num_options || row.option || whichOption,
      id: row.sku || row.Product_Name || row["Product Name"],
      Product_Name: row.sku || row.Product_Name || row["Product Name"],
      name: row.name || row.Name || row["Product Name"],
      Name: row.name || row.Name || row["Product Name"],
      quantity,
      Product_Quantity: quantity,
      pricePerItem: resolvedUnitPrice,
      Product_Base_Price: resolvedUnitPrice,
      totalPriceForItem: resolvedUnitPrice + optionUnitCost,
      Product_Final_Price: lineTotal || (resolvedUnitPrice + optionUnitCost) * quantity,
    };

    if (bucket === "selectedCamera") {
      item.category = "Camera";
      item.Camera_Quantity = quantity;
      item.Camera_Base_Price = resolvedUnitPrice;
      item.Camera_Final_Price = resolvedUnitPrice + optionUnitCost;
    } else if (bucket === "selectedCabling") {
      item.category = "Cabling";
    } else if (bucket === "selectedLabor") {
      item.category = "Labor";
      item.extra_field_4 = item.extra_field_4 || "0";
    } else if (bucket === "selectedNVR") {
      item.category = "DVRs & NVRs/NVR Recorders (IP Cameras)";
    } else if (bucket === "selectedPoE") {
      item.category = "Poe";
      item.Port_Name = item.Product_Name;
      item.Port_Quantity = quantity;
      item.Port_Base_Price = resolvedUnitPrice;
      item.poeFinalPrice = resolvedUnitPrice;
    } else if (bucket === "selectedHardWare") {
      item.category = "Hardware";
      item.basePrice3 = resolvedUnitPrice;
    } else {
      item.category = "Special";
      item.Camera_Quantity = quantity;
      item.Camera_Base_Price = resolvedUnitPrice;
      item.Camera_Final_Price = resolvedUnitPrice + optionUnitCost;
    }

    for (let i = 1; i <= 12; i += 1) {
      const optionName = row[`option${i}_name`];
      if (optionName) {
        item[optionName] = row[`option${i}_value`];
        item[`${optionName}_price`] = Number(row[`option${i}_price`] || 0);
      }
    }

    return item;
  };

  const normalizeImportedCartItem = (item, bucket, row = {}) => {
    const optionNumber =
      item.num_options || item.option || row.num_options || whichOption;
    const { cart_bucket, raw_item_json, options_json, globalOption, ...cleanItem } =
      item || {};

    const rowQuantity = Number(row.quantity || cleanItem.Product_Quantity || cleanItem.Camera_Quantity || cleanItem.quantity || 1);
    const rowLineTotal = Number(row.line_total || cleanItem.Product_Final_Price || 0);
    const rowUnitPrice = Number(row.unit_price || 0) || (rowQuantity ? rowLineTotal / rowQuantity : 0);

    if ((bucket === "selectedSpecial" || cleanItem.Camera_Category_Name === "Custom") && rowUnitPrice) {
      if (cleanItem.Product_Base_Price === undefined || cleanItem.Product_Base_Price === "") cleanItem.Product_Base_Price = rowUnitPrice;
      if (cleanItem.Camera_Base_Price === undefined || cleanItem.Camera_Base_Price === "") cleanItem.Camera_Base_Price = rowUnitPrice;
      if (cleanItem.pricePerItem === undefined || cleanItem.pricePerItem === "") cleanItem.pricePerItem = rowUnitPrice;
      if (cleanItem.Product_Final_Price === undefined || cleanItem.Product_Final_Price === "") cleanItem.Product_Final_Price = rowLineTotal || rowUnitPrice * rowQuantity;
    }

    return {
      ...cleanItem,
      uniqueID:
        cleanItem.uniqueID ||
        row.uniqueID ||
        Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
      num_options: optionNumber,
      option: optionNumber,
    };
  };

  const safelyParseJson = (value, fallback) => {
    if (!value) return fallback;

    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const importCartCsv = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const imported = {
          selectedCamera: [],
          selectedCabling: [],
          selectedLabor: [],
          selectedNVR: [],
          selectedPoE: [],
          selectedHardWare: [],
          selectedSpecial: [],
        };

        let importedTotalOptions = null;
        let importedCustomerData = null;
        let importedOptionHeading = null;
        let importedOptionDisplayText = null;
        let importedOptionDescription = null;
        let importedOptionDiscounts = null;
        let importedCartSnapshot = null;
        let importedQuoteVersion = null;
        let importedQuoteState = {};

        (results.data || []).forEach((row) => {
          if (row.row_type === "quote_metadata") {
            importedQuoteVersion =
              row.quote_version || row.app_version || row.exported_with_version || null;
            importedTotalOptions = Number(row.total_no_options || 0) || null;
            importedCustomerData = safelyParseJson(row.customer_data_json, null);
            importedOptionHeading = safelyParseJson(row.option_heading_json, null);
            importedOptionDisplayText = safelyParseJson(row.option_display_text_json, null);
            importedOptionDescription = safelyParseJson(
              row.option_description_json,
              null
            );
            importedOptionDiscounts = safelyParseJson(row.option_discounts_json, null);
            importedCartSnapshot = safelyParseJson(row.cart_snapshot_json, null);
            importedQuoteState = {
              quoteVersion: importedQuoteVersion || LEGACY_VERSION_LABEL,
              totalCamera: Number(row.total_camera || 0),
              selectedDrops: safelyParseJson(row.selected_drops_json, {}),
              selectedCameraQuantity: safelyParseJson(
                row.selected_camera_quantity_json,
                {}
              ),
              comparisonData: safelyParseJson(row.comparison_data_json, {}),
              optionDiscounts: importedOptionDiscounts || {},
            };
            return;
          }

          let item = null;

          if (row.raw_item_json) {
            try {
              item = JSON.parse(row.raw_item_json);
            } catch (error) {
              item = null;
            }
          }

          if (!item) {
            item = buildImportedItemFromRow(row);
          }

          const bucket = getImportBucket(item, row);
          if (!imported[bucket]) imported[bucket] = [];
          imported[bucket].push(normalizeImportedCartItem(item, bucket, row));
        });

        const safeImportedQuoteVersion = importedQuoteVersion || LEGACY_VERSION_LABEL;


        if (importedTotalOptions) {
          dispatch(totalSelectedOptions(importedTotalOptions));
        }

        dispatch(setImportedQuoteState({
          ...importedQuoteState,
          quoteVersion: safeImportedQuoteVersion,
        }));
        dispatch(setQuoteVersion(safeImportedQuoteVersion));

        if (importedCustomerData) {
          dispatch(setCustomerData(importedCustomerData));
        }

        if (importedOptionHeading) {
          Object.entries(importedOptionHeading).forEach(([option, text]) => {
            dispatch(setOptionHeading({ whichOption: option, text }));
          });
        }

        if (importedOptionDisplayText) {
          Object.entries(importedOptionDisplayText).forEach(([option, text]) => {
            dispatch(setOptionDisplayText({ whichOption: option, text }));
          });
        }

        if (importedOptionDescription) {
          Object.entries(importedOptionDescription).forEach(([option, text]) => {
            dispatch(setOptionDescription({ whichOption: option, text }));
          });
        }

        if (importedCartSnapshot) {
          const cleanSnapshot = sanitizeCartSnapshot(importedCartSnapshot);
          const pricingRefresh = refreshImportedCartPricing(cleanSnapshot, priceCheckProducts, priceCheckProductOptions, areYouDealer);
          const reviewedPricing = await reviewImportPricingChanges(pricingRefresh);
          const refreshedSnapshot = reviewedPricing.cartData;

          dispatch(
            replaceImportedCart({
              selectedCamera: refreshedSnapshot.selectedCamera || [],
              selectedCabling: refreshedSnapshot.selectedCabling || [],
              selectedLabor: refreshedSnapshot.selectedLabor || [],
              selectedNVR: refreshedSnapshot.selectedNVR || [],
              selectedPoE: refreshedSnapshot.selectedPoE || [],
              selectedHardWare: refreshedSnapshot.selectedHardWare || [],
              selectedSpecial: refreshedSnapshot.selectedSpecial || [],
            })
          );
        } else {
          const importedCart = {
            ...imported,
            selectedSpecial: dedupeSpecialItems(imported.selectedSpecial || []),
          };
          const pricingRefresh = refreshImportedCartPricing(importedCart, priceCheckProducts, priceCheckProductOptions, areYouDealer);
          const reviewedPricing = await reviewImportPricingChanges(pricingRefresh);
          dispatch(replaceImportedCart(reviewedPricing.cartData));
        }

        event.target.value = "";
      },
    });
  };

  return (
    <>
      {totalNoOptions === undefined ? (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <h1>Your cart is empty...</h1>
          {renderCartControls()}
        </div>
      ) : (
        <div id="tableToConvert" className="container">
          <div className="row">
            <div className="col-12">
              <div
                style={optionStyle}
                className="d-flex justify-content-between align-items-center mb-3"
              >
                <div style={imgLogo} className="flex-shrink-0">
                  <img
                    style={imgLogo}
                    src="https://platinumcctv.com/assets/images/CCTV_logo.webp"
                    className="img-fluid"
                    alt="Platinum CCTV"
                  />
                </div>
                <div className="flex-grow-1 text-center mx-5">
                  <input
                    type="text"
                    value={getOptionDisplayText(whichOption)}
                    onChange={(e) =>
                      handleOptionDisplayTextChange(whichOption, e.target.value)
                    }
                    className="text-center rounded fw-bold fs-3 border-0"
                    aria-label={`Option ${whichOption} label`}
                  />
                  <input
                    type="text"
                    value={optionHeading[whichOption] || ""} // Handle undefined case
                    onChange={(e) => handleOptionHeadingChange(whichOption, e)} // Pass whichOption
                    className="text-center rounded"
                    placeholder="Add heading here..."
                  />
                </div>
                <div className="flex-shrink-0 text-end">
                  <h6 className="fw-bold mt-auto mb-1">{`Quote# ${QuoteNumber()}-${whichOption}`}</h6>
                  <div className="text-muted small text-end">Quote Version: {displayedQuoteVersion}</div>
                </div>
              </div>

              <div className="d-flex justify-content-between">
                {/* <div>
                  {customerUserData != "" ? (
                    <div className="d-flex justify-content-between">
                      <div className="me-3">
                        Platinum CCTV <br />
                        30W270 Butterfield Rd, #101<br />
                        Warrenville, IL 60555<br />
                        630-225-0693
                      </div>

                      <div className="ms-3">
                        <ul className="list-unstyled">
                          <li>business-name</li>
                          <li>customer-first customer-last</li>
                          <li>phone</li>
                          <li>email</li>
                        </ul>
                      </div>

                      
                      <div>
                        <h4>Customer Details :</h4>
                      </div>

                      {
                        <div className="d-flex">
                          <div style={{ margin: "5px", padding: "5px" }}>
                            <div style={{ margin: "5px" }}>Bill to: </div>
                            <div style={{ margin: "5px" }}>{customerUserData.customerFirstName}</div>
                            <div style={{ margin: "5px", wordWrap: "break-word" }}>{customerUserData.address}</div>
                          </div>

                          <div style={{ margin: "5px", padding: "5px" }}>
                            <div style={{ margin: "5px" }}>Ship to:</div>
                            <div style={{ margin: "5px" }}>{customerUserData.customerName}</div>
                            <div style={{ margin: "5px", wordWrap: "break-word" }}>{customerUserData.address}</div>
                          </div>
                        </div>
                      }
                      <hr /> 
                    </div>
                  ) :
                    null
                  }
                </div> */}
                <div className="d-flex justify-content-between w-100 gap-4">
                  <div className="me-3">
                    Platinum CCTV <br />
                    30W270 Butterfield Rd, #101
                    <br />
                    Warrenville, IL 60555
                    <br />
                    630-225-0693
                  </div>

                  <div className="me-3">
                    <h6 className="fw-semibold">Client Info:</h6>
                    <ul className="list-unstyled">
                      <li>{customerUserData.businessName || ""}</li>
                      <li>
                        {[
                          customerUserData.customerFirstName,
                          customerUserData.customerLastName,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      </li>
                      <li>{customerUserData.phoneNumber || ""}</li>
                      <li>{customerUserData.email || ""}</li>
                    </ul>
                  </div>

                  <div className="me-3">
                    <h6 className="fw-semibold">Billing Address:</h6>
                    <ul className="list-unstyled">
                      <li>{customerUserData.billAddress1 || ""}</li>
                      <li>{customerUserData.billAddress2 || ""}</li>
                      <li>
                        {[
                          customerUserData.billCity,
                          customerUserData.billState,
                          customerUserData.billZip,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </li>
                    </ul>
                  </div>

                  <div className="ms-3">
                    <h6 className="fw-semibold">Ship To:</h6>
                    <ul className="list-unstyled">
                      <li>{customerUserData.shipAddress1 || ""}</li>
                      <li>{customerUserData.shipAddress2 || ""}</li>
                      <li>
                        {[
                          customerUserData.shipCity,
                          customerUserData.shipState,
                          customerUserData.shipZip,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1 me-3">
                  <h6 className="fw-semibold">Details about this Option:</h6>
                  <div className="position-relative">
                    <JoditEditor
                      ref={editor}
                      value={optionDescription[whichOption] || ""}
                      // config={config}
                      tabIndex={1} // tabIndex of textarea
                      // onBlur={newContent => setContent(newContent)}
                      className="text-left rounded"
                      onChange={(newContent) => {
                        handleOptionDescriptionChange(whichOption, newContent);
                      }}
                    />
                  </div>
                </div>

                <div className="flex-shrink-0">
                  <div className="d-flex justify-content-end align-items-end flex-column">
                    <h6 className="fw-bold text-center">
                      Selected Cameras: {totalQuantity["Camera"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      Total Cameras: {totalQuantity["Camera"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      PoE Ports:{" "}
                      {isNaN(totalQuantity["Poe"])
                        ? "Not Defined"
                        : totalQuantity["Poe"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      Licenses: {totalQuantity["Licenses"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      Labor: {totalQuantity["Labor"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      Hardware: {totalQuantity["Hardware"]}
                    </h6>
                    <h6 className="fw-bold text-center">
                      Drops:{" "}
                      {totalQuantity["Drops"] != 0
                        ? totalQuantity["Camera"] + totalQuantity["Drops"]
                        : totalQuantity["Camera"]}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mt-5">
              <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                {renderOptionCountControls()}
                {combinedData.length > 0 && (
                  <div className="d-flex justify-content-end flex-wrap mb-2">
                    {[...Array(totalNoOptions)].map((_, index) =>
                      index + 1 != whichOption ? (
                        <Button
                          onClick={() => handleCopyOptionClick(index + 1)}
                          style={copyBtn}
                          key={index}
                          variant="dark"
                        >{`Copy ${index + 1}`}</Button>
                      ) : null
                    )}
                  </div>
                )}
              </div>

              {filteredCategories(whichOption).map(
                (category, categoryIndex) => {
                  return (
                    <div key={categoryIndex} className="col-12">
                      <div className="heading-margin d-flex justify-content-between">
                        <h4 className="mt-2">{getCartCategoryHeading(category)}</h4>
                        <button
                          className="btn text-white fs-5"
                          // onClick={() => navigate(`/${categoryPaths[category] || categoryPaths['DVRs & NVRs/NVR Recorders (IP Cameras)'] || categoryPaths['Special/Software and Dongles']}`)}
                          onClick={() =>
                            navigate(`/${categoryPaths[category]}`)
                          }
                        >
                          Edit
                        </button>
                      </div>
                      <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table id="customers" style={cartTableStyle}>
                          <colgroup>
                            <col style={{ width: cartColumnStyles.sku.width }} />
                            <col style={{ width: cartColumnStyles.description.width }} />
                            <col style={{ width: cartColumnStyles.price.width }} />
                            <col style={{ width: cartColumnStyles.qty.width }} />
                            <col style={{ width: cartColumnStyles.total.width }} />
                          </colgroup>
                          <tbody>
                            {isNvrCartCategory(category) && (
                              <tr className="paddingTest">
                                <th style={cartColumnStyles.sku}>SKU</th>
                                <th style={cartColumnStyles.description}>Description & Options</th>
                                <th style={cartColumnStyles.price}>Price</th>
                                <th style={cartColumnStyles.qty}>QTY</th>
                                <th style={cartColumnStyles.total}>Total</th>
                              </tr>
                            )}
                            {combinedData
                              .filter((item) => {
                                if (
                                  isNvrCartCategory(category) &&
                                  item.option == whichOption
                                ) {
                                  return [
                                    "DVRs & NVRs/NVR Recorders (IP Cameras)",
                                    "DVRs & NVRs/NVR Recorders (IP Cameras)@Special/Software and Dongles",
                                  ].includes(item.category);
                                }
                                return (
                                  item.category === category &&
                                  item.option == whichOption
                                );
                              })
                              .map((item, idx) => (
                                <tr key={idx} className="paddingTest">
                                  <td style={cartColumnStyles.sku} title={item.Product_Name}>
                                    {item.Product_Name}
                                  </td>
                                  <td style={cartColumnStyles.description}>
                                    {renderCartDescription(item)}
                                  </td>
                                  <td style={cartColumnStyles.price}>
                                    ${getCartUnitPrice(item).toFixed(2)}
                                  </td>
                                  <td style={cartColumnStyles.qty}>
                                    {getCartQuantity(item)}
                                  </td>
                                  <td style={cartColumnStyles.total}>
                                    ${getCartLineTotal(item).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            {CartTotalAMT > 0 ? (
              <div className="col-12 d-flex justify-content-end mb-4">
                <div className="text-end fw-bold">
                  <div>Parts Total: ${getCartPartsTotal().toFixed(2)}</div>
                  <div>Labor Total: ${getCartLaborTotal().toFixed(2)}</div>
                  <div className="d-flex justify-content-end align-items-center gap-2 mt-1">
                    <label className="mb-0">Discount:</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={getOptionDiscount(whichOption) || ""}
                      onChange={(e) => handleOptionDiscountChange(whichOption, e.target.value)}
                      className="form-control form-control-sm text-end"
                      style={{ maxWidth: "130px" }}
                      placeholder="0.00"
                    />
                  </div>
                  <div className="border-top mt-1 pt-1">
                    Total: ${Math.max(0, CartTotalAMT - getOptionDiscount(whichOption)).toFixed(2)}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {renderCartControls()}

            <div className="col-12">
              <Modal show={showBuildPacket} onHide={() => setShowBuildPacket(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Build Quote Packet</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="mb-3">Select the packet material to include after the quote.</p>
              <select
                className="form-select"
                value={selectedPacketType}
                onChange={(event) => setSelectedPacketType(event.target.value)}
              >
                {packetTypes.map((packet) => (
                  <option key={packet.value} value={packet.value}>
                    {packet.label}
                  </option>
                ))}
              </select>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowBuildPacket(false)}>
                Cancel
              </Button>
              <Button variant="dark" onClick={handleBuildPacket}>
                Build Packet
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showConfirm} onHide={handleCancelCopy} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Confirm Copy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Are you sure you want to copy option {optionToCopy} to the
                  current option?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCancelCopy}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleConfirmCopy}>
                    Confirm
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HigherOrderComponent(Cart);
